import { openDB, IDBPDatabase } from 'idb';

type DBSchema = {
  sets: { key: string; value: any; };
};

let dbPromise: Promise<IDBPDatabase<DBSchema>> | null = null;

function getDb() {
  if (!dbPromise) {
    dbPromise = openDB<DBSchema>('binder-cache', 1, {
      upgrade(db) {
        if (!db.objectStoreNames.contains('sets')) {
          db.createObjectStore('sets');
        }
      },
    });
  }
  return dbPromise;
}

export async function getSetFromCache(slug: string) {
  const db = await getDb();
  return db.get('sets', slug);
}

export async function putSetInCache(slug: string, data: any) {
  const db = await getDb();
  await db.put('sets', data, slug);
}


